import PageTitle from "../components/PageTitle/PageTitle";

//Import des médias de la home
import Home_image from '../assets/img/home/01_Home.jpg';

// Import des médias de la question 1
import Q1ImageFantome from "../assets/img/q1/A_1920_Radio_Ducretet_75.webp";
import Q1Image1_desktop from "../assets/img/q1/desktop/02_1920_Enregistrement_Concert_RESIZED_75.webp";
import Q1Image1_mobile from "../assets/img/q1/mobile/02_1920_Enregistrement_Concert_RESIZED_75.webp";
import Q1Video_thumb from "../assets/video/q1/03_1920_Femmes_ecoutent_radio_Capture_75.webp";

import Q2ImageFantome from "../assets/img/q2/B_1938_Radio_Sonora_75.webp";
import Q2Image1_desktop from "../assets/img/q2/desktop/04_1938_Canular_Orson_Welles_RESIZED_75.jpg";
import Q2Image1_mobile from "../assets/img/q2/mobile/04_1938_Canular_Orson_Welles_RESIZED_75.jpg";
import Q2Image2_desktop from "../assets/img/q2/desktop/05_1938_De_Gaulle_18juin_RESIZED_75.webp";
import Q2Image2_mobile from "../assets/img/q2/mobile/05_1938_De_Gaulle_18juin_RESIZED_75.webp";

// Import des images de la question 3
import Q3ImageFantome from "../assets/img/q3/C_1950_Radio_Microcapte_75.webp";
import Q3Image1_desktop from "../assets/img/q3/desktop/06_1960_Autoradio_RESIZED_75.webp";
import Q3Image1_mobile from "../assets/img/q3/mobile/06_1960_Autoradio_RESIZED_75.webp";
import Q3Image2_desktop from "../assets/img/q3/desktop/07_1960_Match_Baseball-retouchee_RESIZED_75.webp";
import Q3Image2_mobile from "../assets/img/q3/mobile/07_1960_Match_Baseball-retouchee_RESIZED_75.webp";

// Import des images de la question 4
import Q4ImageFantome from "../assets/img/q4/D_1968_Radio_Boule_Philipps_75.webp";
import Q4Image1_desktop from "../assets/img/q4/desktop/08_1968_Femme_Leve_Poing_RESIZED_75.webp";
import Q4Image1_mobile from "../assets/img/q4/mobile/08_1968_Femme_Leve_Poing_RESIZED_75.webp";
import Q4Image2_desktop from "../assets/img/q4/desktop/10_1968_Radio_Verte_RESIZED_75.webp";
import Q4Image2_mobile from "../assets/img/q4/mobile/10_1968_Radio_Verte_RESIZED_75.webp";
import Q4Video1_thumb from "../assets/video/q4/09_1968_Lancer_de_pave_Capture_75.webp";

// Import des images de la question 5
import Q5ImageFantome from "../assets/img/q5/E_1980_Radio_Boombox_Promax_75.webp";
import Q5Image1_desktop from "../assets/img/q5/desktop/11_1980_Breakdance_1042_75.webp";
import Q5Image1_mobile from "../assets/img/q5/mobile/11_1980_Breakdance_600_75.webp";
import Q5Video1_thumb from "../assets/video/q5/12_1980_Hard_Rock_capture_75.webp";

// Import des images de la question 6
import Q6ImageFantome from "../assets/img/q6/F_2000_Airpods_75.webp";
import Q6Video1_thumb from "../assets/video/q6/13_2000_Personne_Metro_Capture_75.webp";

// Imports des images présentes dans la page de résultat
import festive_radio1_revetement from '../assets/img/results/pastilles/festive/Festive_03_Revetement_Jambon_RESIZED_75.webp';
import intime_tache from '../assets/img/results/pastilles/intime/INTIME_03_Tache_LovinFun_RESIZED_75.webp';
import politique_eraflure_roosvelt from '../assets/img/results/pastilles/politique/POLITIQUE_03_Pastille_Eraflure_Roosevelt_75.webp';
import intime_volume_plage from '../assets/img/results/pastilles/intime/INTIME_04_Volume_Plage_75.webp';
import politique_desktop from "../assets/img/results/banniere/desktop/POLITIQUE_00_Banniere_RESIZED_75.webp";
import politique_mobile from "../assets/img/results/banniere/mobile/POLITIQUE_00_Banniere_RESIZED_75.webp";

function APropos() {
    // Déclaration de l'aria-label du bouton
    let buttonReturnAriaLabel = "retour à la page d'accueil";

    return (
        <>
            <PageTitle title={`Si j'étais une radio... A propos`} />
            <div className="page page--credits">
                <header role="banner">
                    <nav role="navigation">
                        <button
                            onClick={() => {
                                history.back();
                            }}
                            className="button button--light button--icon button--return button--arrow button--arrow-reverse"
                            aria-label={buttonReturnAriaLabel}>
                            <span className="sr-only">retour</span>
                        </button>
                    </nav>
                </header>
                <main role="main">
                    <h1>à propos</h1>
                    <section>
                        <h2>Production</h2>
                        <p>
                            Cette expérience a été réalisée par les équipes d’Universcience
                            dans le cadre de l’exposition <em>Machine arrière #1 : le radio-transistor</em>{' '}
                            présentée à la Cité des sciences et de l’industrie.
                        </p>
                        <ul>
                            <li>Conception et gestion de projet : Anne-Sophie Rincel</li>
                            <li>Idéation : Anne Perez</li>
                            <li>Design : Antoine Laporte</li>
                            <li>Développement : Wilfried Jumelle</li>
                            <li>Accessibilité : Stéphanie Giacchi</li>
                            <li>Iconographie : Claire Jullion, Cyril Wiet</li>
                            <li>Commissariat de l’exposition : Samia Lorrain-Djidar, Julia Maciel</li>
                        </ul>
                        <p>
                            Le poste de radio Radio-Célard Microcapte a été numérisé et modélisé en 3D par la société Art Graphique & Patrimoine.
                        </p>
                        <ul>
                            <li>Pilotage de projet : Florian Moreno</li>
                            <li>Direction artistique et production : Sébastien Le Gall</li>
                        </ul>
                        <p>
                            Les contenus de l’expérience ont été produits avec l’aide
                            de Thierry Lefebvre, secrétaire de la section « Sciences,
                            Histoire et patrimoine des sciences et des techniques et
                            Archéologie industrielle » du Comité des travaux historiques
                            et scientifiques (CTHS) et ancien maître de conférence à
                            l’Université Paris Cité.
                        </p>
                    </section>
                    <section>
                        <h2>Crédits photos & vidéos</h2>
                        <ul className="credits__medias-list">
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Home_image} media="(min-width: 600px)" />
                                        <img src={Home_image} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Jeune fille portant un casque d’écoute, vers 1930.<br/>
                                            &copy; General Photographic Agency/Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q1ImageFantome} media="(min-width: 600px)" />
                                        <img src={Q1ImageFantome} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Récepteur radio Ducretet, type Piano, 1921.<br/>
                                            &copy; Perrine Le Maignan/Musée de Radio France
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q1Image1_desktop} media="(min-width: 600px)" />
                                        <img src={Q1Image1_mobile} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Orchestre des concerts Radiola, au studio de TSF du journal Le Matin,
                                            boulevard Haussmann Paris, 1922.<br/>
                                            In La Nature, 1934, en ligne sur <a target="_blank" className="link link--external" href="http://cnum.cnam.fr/redir?4KY28.127">Cnum - Conservatoire numérique des Arts et Métiers.</a>
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q1Video_thumb} media="(min-width: 600px)" />
                                        <img src={Q1Video_thumb} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Jeunes femmes écoutant la radio, vers 1920.<br/>
                                            &copy; Archive Films/Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q2ImageFantome} media="(min-width: 600px)" />
                                        <img src={Q2ImageFantome} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Radio Sonora Excellence 301, 1948.<br/>
                                            &copy; Radiomuseum.org
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q2Image1_desktop} media="(min-width: 600px)" />
                                        <img src={Q2Image1_mobile} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Lecture de La guerre des mondes, de H.G. Wells,
                                            par Orson Welles dans les studios de CBS, New York, 1938.<br/>
                                            &copy; Gamma-Keystone/Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q2Image2_desktop} media="(min-width: 600px)" />
                                        <img src={Q2Image2_mobile} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Le général Charles de Gaulle au micro de la BBC à Londres, 1941.<br/>
                                            &copy; Hulton-Deutsch Collection/CORBIS/Corbis via Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q3ImageFantome} media="(min-width: 600px)" />
                                        <img src={Q3ImageFantome} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Radio Microcapte et détails.<br/>
                                            &copy; Antoine Laporte
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q3Image1_desktop} media="(min-width: 600px)" />
                                        <img src={Q3Image1_mobile} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Le premier autoradio au Salon de l&apos;automobile de
                                            Francfort-sur-le-Main, Allemagne, 1959.<br/>
                                            &copy; Keystone-France/Gamma-Keystone via Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q3Image2_desktop} media="(min-width: 600px)" />
                                        <img src={Q3Image2_mobile} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Dans les gradins. Match de baseball Yankees-Red
                                            Sox, 23 septembre 1950.<br/>
                                            &copy; Bettmann Archives/Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q4ImageFantome} media="(min-width: 600px)" />
                                        <img src={Q4ImageFantome} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Poste radio « boule » Philips 20 RL 010, 1974.<br/>
                                            &copy; Anne-Sophie Rincel
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q4Image1_desktop} media="(min-width: 600px)" />
                                        <img src={Q4Image1_mobile} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Paris, mai 1968.<br/>
                                            &copy; Marc Riboud / Fonds Marc Riboud au musée Guimet
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q4Video1_thumb} media="(min-width: 600px)" />
                                        <img src={Q4Video1_thumb} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Mai 68.<br/>
                                            &copy; ITN/Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q4Image2_desktop} media="(min-width: 600px)" />
                                        <img src={Q4Image2_mobile} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Dans le « studio » de Radio Verte, radio clandestine émettant à Paris, 16 mai 1977.<br/>
                                            &copy; Laurent Maous/Gamma-Rapho via Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q5ImageFantome} media="(min-width: 600px)" />
                                        <img src={Q5ImageFantome} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Promax Super Jumbo boombox, utilisée dans le film «&nbsp;Do the right
                                            thing&nbsp;» de Spike Lee en 1989.<br/>
                                            Collection of the Smithsonian National Museum of African
                                            American History and Culture – CC0
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q5Image1_desktop} media="(min-width: 600px)" />
                                        <img src={Q5Image1_mobile} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Breakdance à Marseille, années 90.<br/>
                                            &copy; Photo by Jean-Erick PASQUIER/Gamma-Rapho via Getty
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q5Video1_thumb} media="(min-width: 600px)" />
                                        <img src={Q5Video1_thumb} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Le hard rock en France, «&nbsp;un sacré marché&nbsp;». Émission Les enfants du rock, 1984.<br/>
                                            &copy; Les enfants du rock/France2/INA
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q6ImageFantome} media="(min-width: 600px)" />
                                        <img src={Q6ImageFantome} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            AirPods d&apos;Apple.<br/>
                                            &copy; Seremin/Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={Q6Video1_thumb} media="(min-width: 600px)" />
                                        <img src={Q6Video1_thumb} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Écoute au casque dans les transports en commun.<br/>
                                            &copy; Counter/Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={festive_radio1_revetement} media="(min-width: 600px)" />
                                        <img src={festive_radio1_revetement} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Récepteur radio Philips dite Boite à jambon, 1931.<br/>
                                            &copy; Perrine Le Maignan/Musée de Radio France
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={intime_tache} media="(min-width: 600px)" />
                                        <img src={intime_tache} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Doc & Difool, animateurs de Radio Fun. <br/>
                                            &copy; Eric Robert/Sygma/Sygma via Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={politique_eraflure_roosvelt} media="(min-width: 600px)" />
                                        <img src={politique_eraflure_roosvelt} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Le président Franklin D. Roosevelt durant l&apos;un de ses discours «&nbsp;au coin du feu&nbsp;». Avril 1942.<br/>
                                            &copy; <a target="_blank" href="https://www.gettyimages.fr/search/photographer?photographer=Bettmann">Bettmann</a>/Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={intime_volume_plage} media="(min-width: 600px)" />
                                        <img src={intime_volume_plage} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            La radio est partout... 1982.<br />
                                            &copy; Barbara Alper/Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                            <li>
                                <figure className="grid--container">
                                    <picture className="quiz-figure__media-picture">
                                        <source srcSet={politique_desktop} media="(min-width: 600px)" />
                                        <img src={politique_mobile} alt='image légendée' />
                                    </picture>
                                    <figcaption>
                                        <p>
                                            Etudiants dans la manifestation du 13 mai 68 à Paris.<br/>
                                            &copy; Keystone-France/Gamma-Rapho via Getty Images
                                        </p>
                                    </figcaption>
                                </figure>
                            </li>
                        </ul>
                    </section>
                    <section>
                        <h2>Remerciements</h2>
                        <ul>
                            <li>Cécile de David-Beauregard, Musée de Radio-France</li>
                            <li>Florence Desnoyers, Bibliothèque du CNAM</li>
                            <li>Lorène Durret, Association Les amis de Marc Riboud</li>
                            <li>Perrine Le Maignan, photographe</li>
                            <li>Patrice Zeissloff, Radiomuseum.org</li>
                        </ul>
                    </section>
                </main>
            </div>
        </>

    )
}

export default APropos
